<!-- 导入直销员 -->
<template>
  <div class="power">
    <div style="padding: 16px">
      <van-cell-group>
        <van-cell size="large" title="请上传Excel 表格" />
        <van-cell size="large" title="1. 上传仅支持 Excel 文件，且文件内只有一列手机号码，不能含有除手机号以外的其他信息，否则会上传失败；" />
        <van-cell size="large" :border="false" title="2. 如果上传的Excel文件包括已经存在的人员手机号或活动不可见人员的手机号都会报错提示。" />
        <div class="flex-center" style="justify-content: center; padding: 16px 0">
          <van-uploader
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :after-read="afterRead"
            result-type="file"
            :before-read="beforeRead"
          >
            <van-button round style="width: 285px; background: linear-gradient(270deg, #306fe2 24.05%, #1f7dde 73.62%); color: #fff">上传</van-button>
          </van-uploader>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      activityId: "",
      groupId: "",
    };
  },
  methods: {
    beforeRead(file) {
      const name = file.name.toLowerCase().split(".").pop();
      console.log(name);
      if (["xls", "xlsx"].indexOf(name) === -1) {
        this.$Toast("只能上传.xls.xlsx类型的文件");
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      const param = new FormData();
      param.append("excelFile", file.file);
      console.log(file.file);
      this.$http
        .post(`aocampaignsales/openapi/sales/data/bulkAddSales/${this.activityId}/${this.groupId}`, param, {
          headers: {
            Authorization: `Bearer ${this.$route.query.token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res) {
            if (res.data && res.data.noPermissionMobiles && res.data.noPermissionMobiles.length) {
              console.log(res.data.noPermissionMobiles);
              const mobiles = res.data.noPermissionMobiles;
              let message = "请勿导入不在活动可见范围内的手机号";
              if (mobiles.length >= 2) {
                message = `${mobiles[0]}、${mobiles[1]}...请勿导入不在活动可见范围内的手机号`;
              } else if (mobiles.length === 1) {
                message = `${mobiles[0]}...请勿导入不在活动可见范围内的手机号`;
              }
              this.showError("部分手机号导入失败", message);
            } else if (res.data && res.data.repeatMobiles && res.data.repeatMobiles.length) {
              console.log(res.data.repeatMobiles);
              const mobiles = res.data.repeatMobiles;
              let message = "请勿重复导入同一手机号";
              if (mobiles.length >= 2) {
                message = `${mobiles[0]}、${mobiles[1]}...请勿重复导入同一手机号`;
              } else if (mobiles.length === 1) {
                message = `${mobiles[0]}...请勿重复导入同一手机号`;
              }
              this.showError("部分手机号导入失败", message);
            } else {
              this.$Toast.success("上传成功");
              setTimeout(() => {
                window.wx.miniProgram.navigateBack();
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.log("upload", err);
          this.$Toast.clear()
          this.showError("导入失败", err.response.data.message);
        });
    },
    showError(title, message) {
      this.$Dialog.alert({
        title: title,
        message: message,
        confirmButtonText: "我知道了",
        confirmButtonColor: "#3388FF",
        width: "310px",
      });
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.activityId) {
      this.activityId = query.activityId;
    }
    if (query.groupId) {
      this.groupId = query.groupId;
    }
  },
};
</script>

<style lang="less" scoped>
.power {
  background: #f7f8fa;
  height: 100vh;
}
.van-cell-group {
  border-radius: 5px;
  overflow: hidden;
}
</style>
